export default "__VITE_ASSET__6c214cc5__"